import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { AutocompleteControl } from 'components/_basic/Form/Autocomplete';
import { SECTOR_OPTIONS_DEU } from 'components/BusinessToolForm/constants/deu/industrySectorOptions_deu';
import { SECTOR_OPTIONS_ES } from 'components/BusinessToolForm/constants/es/industrySectorOptions_es';
import { SECTOR_OPTIONS } from 'components/BusinessToolForm/constants/industrySectorOptions';
import { SECTOR_OPTIONS_UA } from 'components/BusinessToolForm/constants/ua/industrySectorOptions_ua';

import {
  COMPANY_INDUSTRY_GROUP_FIELD_NAME,
  GLOBAL_FIELD_NAMES,
  INDUSTRY_FIELD_NAME,
  SECTOR_FIELD_NAME,
  SUB_SECTOR_FIELD_NAME,
  useGetGlobalInitialValues,
} from '../../form';
import { IIndustryDropdownProps as IProps } from '../types';

export const SectorDropdown: FC<IProps> = ({ disabled, id }) => {
  const globalInitialValues = useGetGlobalInitialValues();
  const { t, i18n } = useTranslation();
  const { control, setValue } = useFormContext();

  const fieldChangeHandler = () => {
    setValue(SUB_SECTOR_FIELD_NAME, globalInitialValues[GLOBAL_FIELD_NAMES.COMPANY_SUB_SECTOR]);
    setValue(COMPANY_INDUSTRY_GROUP_FIELD_NAME, globalInitialValues[GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY_GROUP]);
    setValue(INDUSTRY_FIELD_NAME, globalInitialValues[GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY]);
  };

  const getOptions = (lang: string) => {
    switch (lang) {
      case 'de':
        return SECTOR_OPTIONS_DEU;
      case 'uk':
        return SECTOR_OPTIONS_UA;
      case 'es':
        return SECTOR_OPTIONS_ES;
      default:
        return SECTOR_OPTIONS;
    }
  };

  return (
    <Grid item xs={12}>
      <AutocompleteControl
        control={control}
        label={t('sector')}
        id={id ?? SECTOR_FIELD_NAME}
        name={SECTOR_FIELD_NAME}
        options={getOptions(i18n.language)}
        disabled={disabled}
        onChange={fieldChangeHandler}
        onFieldClear={fieldChangeHandler}
      />
    </Grid>
  );
};
